import { render, staticRenderFns } from "./TicketHistoryDialog.vue?vue&type=template&id=851728b6"
import script from "./TicketHistoryDialog.vue?vue&type=script&lang=js"
export * from "./TicketHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports